// source: pbtypes/gen/vehicle_params_for_phone/return_settings_limits.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_gen_vehicle_params_for_phone_return_settings_pb = require('../../../pbtypes/gen/vehicle_params_for_phone/return_settings_pb.js');
goog.object.extend(proto, pbtypes_gen_vehicle_params_for_phone_return_settings_pb);
goog.exportSymbol('proto.vehicle_params_for_phone.ReturnSettingsLimits', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vehicle_params_for_phone.ReturnSettingsLimits, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vehicle_params_for_phone.ReturnSettingsLimits.displayName = 'proto.vehicle_params_for_phone.ReturnSettingsLimits';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.toObject = function(opt_includeInstance) {
  return proto.vehicle_params_for_phone.ReturnSettingsLimits.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vehicle_params_for_phone.ReturnSettingsLimits} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.toObject = function(includeInstance, msg) {
  var f, obj = {
minSettings: (f = msg.getMinSettings()) && pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.toObject(includeInstance, f),
maxSettings: (f = msg.getMaxSettings()) && pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vehicle_params_for_phone.ReturnSettingsLimits;
  return proto.vehicle_params_for_phone.ReturnSettingsLimits.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vehicle_params_for_phone.ReturnSettingsLimits} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.deserializeBinaryFromReader);
      msg.setMinSettings(value);
      break;
    case 2:
      var value = new pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings;
      reader.readMessage(value,pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.deserializeBinaryFromReader);
      msg.setMaxSettings(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vehicle_params_for_phone.ReturnSettingsLimits.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vehicle_params_for_phone.ReturnSettingsLimits} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMinSettings();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.serializeBinaryToWriter
    );
  }
  f = message.getMaxSettings();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings.serializeBinaryToWriter
    );
  }
};


/**
 * optional ReturnSettings min_settings = 1;
 * @return {?proto.vehicle_params_for_phone.ReturnSettings}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.getMinSettings = function() {
  return /** @type{?proto.vehicle_params_for_phone.ReturnSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings, 1));
};


/**
 * @param {?proto.vehicle_params_for_phone.ReturnSettings|undefined} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits} returns this
*/
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.setMinSettings = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits} returns this
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.clearMinSettings = function() {
  return this.setMinSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.hasMinSettings = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ReturnSettings max_settings = 2;
 * @return {?proto.vehicle_params_for_phone.ReturnSettings}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.getMaxSettings = function() {
  return /** @type{?proto.vehicle_params_for_phone.ReturnSettings} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_vehicle_params_for_phone_return_settings_pb.ReturnSettings, 2));
};


/**
 * @param {?proto.vehicle_params_for_phone.ReturnSettings|undefined} value
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits} returns this
*/
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.setMaxSettings = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vehicle_params_for_phone.ReturnSettingsLimits} returns this
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.clearMaxSettings = function() {
  return this.setMaxSettings(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vehicle_params_for_phone.ReturnSettingsLimits.prototype.hasMaxSettings = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.vehicle_params_for_phone);
